export default {
      id: "help-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#help",
      toString: function () {
        return this.url;
      }
    }